"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Misionesusafeature() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="misionesusafeature" data-nav="light" className="bg-background py-8 sm:py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl md:rounded-3xl shadow-lg group">
          {}
          <div className="relative aspect-[16/9] min-h-[460px] sm:min-h-[500px] md:min-h-[560px] w-full overflow-hidden bg-muted">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/missions_crowd_worship.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/missions_crowd_worship.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/missions_crowd_worship.png-wvc-sizes" alt="Diverse congregation with hands raised in worship" loading="lazy" decoding="async" className="h-full w-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-105" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent md:hidden" />
          </div>

          {}
          <div className="relative md:absolute bottom-0 left-0 p-4 sm:p-6 md:p-8 md:max-w-xl lg:max-w-2xl w-full">
            <motion.div initial={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2,
            ease: "easeOut"
          }} className="bg-background text-foreground rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 shadow-xl border border-border/60">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground font-default">MISIONES LOCALES</h2>
              <p className="mt-3 sm:mt-4 text-sm sm:text-base leading-relaxed text-muted-foreground">Misiones se enfoca estratégicamente en llevar la esperanza de Jesús a diversos grupos relacionales, étnicos, culturales y de necesidades en COSTA RICA.</p>
              <div className="mt-5 sm:mt-6">
                <Button asChild className="rounded-full bg-foreground text-background hover:bg-foreground/90 px-6 py-2.5 sm:px-7 sm:py-3 text-xs sm:text-sm font-semibold uppercase tracking-wider shadow-md transition-transform active:scale-95">
                  <Link to="/MinistriesPage" className="inline-flex items-center gap-2">
                    <span>MÁS INFORMACIÓN</span>
                    <ArrowUpRight className="size-4 shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </Link>
                </Button>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}